import { abbreviate } from '../number'

export const bytesToGibs = (bytes: number) => bytes / 1024 / 1024 / 1024

export const gibsToBytes = (gibs: number) => gibs * 1024 ** 3

const BYTES_TO_GIB_THRESHOLD = 1_073_741_824 // ~1 GiB in bytes

/**
 * Formats OTA traffic values, converting to TB when >= 1000 GB
 * @param value - The value in GB (or bytes if value > BYTES_TO_GIB_THRESHOLD)
 * @param includeUnit - Whether to include the unit suffix (GB) for values < 1000 GB
 * @returns Formatted string (e.g., "1.5 TB" or "500" or "500 GB" if includeUnit is true)
 */
export const formatOTAValue = (value: number | null, includeUnit: boolean = false): string => {
	if (value === null || value === undefined) return includeUnit ? `0 GB` : '0'

	// Convert bytes to GB if needed
	const valueInGB = value > BYTES_TO_GIB_THRESHOLD ? bytesToGibs(value) : value

	// Convert to TB if >= 1000 GB
	if (valueInGB >= 1000) {
		const valueInTB = valueInGB / 1000
		return `${abbreviate(valueInTB, true)} TB`
	}

	const formatted = abbreviate(valueInGB, true)
	return includeUnit ? `${formatted} GB` : formatted
}

export default {
	bytesToGibs,
	gibsToBytes,
	formatOTAValue,
}
